import { menuConstants } from "../constants/menuConstants";
import { contentConstants } from "../constants/contentConstants";
import { config } from "../helpers/config";
import { authConstants } from "../constants/authenticationConstants";
import i18n from 'i18next'; // ✅ import i18next instance

export const menuActionCreators = {
    requestMenuElements: key => async dispatch => {
        const currentLang = i18n.language || "bg"; // ✅ use current i18n language
        const url = `${config.base}api/menu/?key=${key}&lang=${currentLang}`; // ✅ include language
        try {
            const response = await fetch(url);
            const elements = await response.json();
            dispatch({
                type: menuConstants.REQUEST_MENU_ELEMENTS,
                elements
            });
        } catch (ex) {
            console.error("Error fetching menu elements:", ex);
        }
    },

    requestSubmenuElements: articleId => async dispatch => {
        const currentLang = i18n.language || "bg";
        const url = `${config.base}api/menu/byarticle/${articleId}?lang=${currentLang}`;
        try {
            const response = await fetch(url);
            const submenuElements = await response.json();

            dispatch({
                type: menuConstants.REQUEST_SUBMENU_ELEMENTS,
                submenuElements
            });
        } catch (ex) {
            console.error("Error fetching submenu elements:", ex);
        }
    },

    searchNews: searchTerm => async dispatch => {
        const currentLang = i18n.language || "bg";
        const url = `${config.base}api/Content/SearchNews?searchTerm=${encodeURIComponent(searchTerm)}&lang=${currentLang}`;
        try {
            const response = await fetch(url);
            const news = await response.json();
            dispatch({
                type: contentConstants.REQUEST_NEWS,
                news
            });
        } catch (ex) {
            console.error("Error searching news:", ex);
        }
    },

    searchEvents: searchTerm => async dispatch => {
        const currentLang = i18n.language || "bg";
        const url = `${config.base}api/Content/SearchEvents?searchTerm=${encodeURIComponent(searchTerm)}&lang=${currentLang}`;
        try {
            const response = await fetch(url);
            const events = await response.json();
            dispatch({
                type: contentConstants.REQUEST_EVENTS,
                events
            });
        } catch (ex) {
            console.error("Error searching events:", ex);
        }
    },

    removeSearch: () => async dispatch => {
        const currentLang = i18n.language || "bg";
        try {
            const newsUrl = `${config.base}api/Content/news?lang=${currentLang}`;
            const newsResponse = await fetch(newsUrl);
            const news = await newsResponse.json();

            const eventsUrl = `${config.base}api/Content/events?lang=${currentLang}`;
            const eventsResponse = await fetch(eventsUrl);
            const events = await eventsResponse.json();

            dispatch({
                type: contentConstants.REQUEST_EVENTS,
                events
            });
            dispatch({
                type: contentConstants.REQUEST_NEWS,
                news
            });
        } catch (ex) {
            console.error("Error resetting search:", ex);
        }
    },
};



//import { menuConstants } from "../constants/menuConstants";
//import { contentConstants } from "../constants/contentConstants";
//import { config } from "../helpers/config";
//import { authConstants } from "../constants/authenticationConstants";

//export const menuActionCreators = {
//	requestMenuElements: key => async dispatch => {
//		const url = `${config.base}api/menu/?key=${key}`;
//		try {
//			const response = await fetch(url);
//			const elements = await response.json();
//			dispatch({
//				type: menuConstants.REQUEST_MENU_ELEMENTS,
//				elements: elements
//			});
//		} catch (ex) {}
//	},

//	requestSubmenuElements: articleId => async dispatch => {
//		const url = `${config.base}api/menu/byarticle/${articleId}`;
//		const response = await fetch(url);
//		const submenuElements = await response.json();

//		dispatch({
//			type: menuConstants.REQUEST_SUBMENU_ELEMENTS,
//			submenuElements: submenuElements
//		});
//	},

//	searchNews: searchTerm => async dispatch => {
//		const url = `${config.base}api/Content/SearchNews?searchTerm=${searchTerm}`;
//		const response = await fetch(url);
//		const news = await response.json();
//		dispatch({
//			type: contentConstants.REQUEST_NEWS,
//			news
//		});
//	},

//	searchEvents: searchTerm => async dispatch => {
//		const url = `${config.base}api/Content/SearchEvents?searchTerm=${searchTerm}`;
//		const response = await fetch(url);
//		const events = await response.json();
//		dispatch({
//			type: contentConstants.REQUEST_EVENTS,
//			events
//		});
//    },

//	removeSearch: () => async dispatch => {
//		const newsUrl = `${config.base}api/Content/news`;
//		const newsResponse = await fetch(newsUrl);
//		const news = await newsResponse.json();
//		const eventsUrl = "api/Content/events";

//		const eventsResponse = await fetch(eventsUrl);
//		const events = await eventsResponse.json();

//		dispatch({
//			type: contentConstants.REQUEST_EVENTS,
//			events
//		});
//		dispatch({
//			type: contentConstants.REQUEST_NEWS,
//			news
//		});
//    },
//};
